<template>
    <!-- 
        CETTE PAGE EST UTILISER JUSTE POUR ENVOYER DES EVENEMENT A GOOGLE ANALYTICS
        PROBLEME : 
        Il y a des produit qui on des etapes et d'autre non
        Celui avec des etape ne sont pas ajouter directement au panier, mais il sont redireger vers la page Etapes.vue
        Celui sans etape sont ajouter directement au panier attraver le controleur InscriptionController qui fais ça avec du PHP

        SOLUTION :
        La creation de cette page qui va envoyer un evenement a Google Analytics et rediriger l'utilisateur vers la page Panier.vue dans les 2 cas
    -->
</template>

<script>
import App from '@/Layouts/App'

export default {
    name: "AddToCart",
    layout: App,
    props: {
        item: Object,
    },
    data: function () {
        return {}
    },
    created:function() {
        let tarif = this.item.produit.tarifs.find(tarif => {
            return tarif.annee == (new Date()).getFullYear();
        });
        if (!tarif) tarif = this.item.produit.tarifs[0];

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                currency: "EUR",
                value: tarif.montant * this.item.quantity,
                items: [
                    {
                        item_id: this.item.produit.id,
                        item_name: this.__(this.item.produit.slug),
                        item_category: this.__(this.item.type.slug),
                        item_list_id: this.item.categorie.id,
                        item_list_name: this.__(this.item.categorie.slug),
                        price: tarif.montant,
                        quantity: this.item.quantity,
                    }
                ]
            }
        });

        // Redirection vers la page Panier.vue using Inertia
        this.$inertia.visit(route('panier.index'));
    },
}
</script>
